import axios from 'axios';
import { getCookie } from "@/helpers/helpers";

export default {
    async requestToken({ state, commit }) {
        commit('loadingTokens');

        try {
            const response = await axios.post(`${process.env.VUE_APP_BACKEND_API}/login/`, state.data);
            commit('successTokens', response.data);
            commit('resetSuccessTokens');
            return true;
        } catch(error) {
            commit('errorTokens', error.response.data);
            return false;
        }
    },
    async requestUpdateToken({ commit }) {
        commit('loadingTokens');

        try {
            const response = await axios.post(
                `${process.env.VUE_APP_BACKEND_API}/refresh/`, 
                { refresh: getCookie('tokenRefresh') }
            );
            commit('successTokens', response.data);
            commit('resetSuccessTokens');
            return true;
        } catch(error) {
            commit('errorTokens', error.response.data);
            return false;
        }
    },
};
